import { useEffect, useState } from "react";

// The one place the mobile breakpoint is written in JS. It has to agree with the
// `@media (max-width: 720px)` block in crm.css: the phone layouts are not just
// CSS — swipe-to-act, column paging and long-press-to-move are touch grammar
// that must not be wired up on a desktop pointer, so components ask this rather
// than guessing from `ontouchstart`.
export const MOBILE_QUERY = "(max-width: 720px)";

export default function useIsMobile() {
  const [mobile, setMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setMobile(e.matches);
    setMobile(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return mobile;
}
